import { ToastStatus } from '../../../../../constants/toastMessage.constants';

import { getRandom } from '../../../../../helpers/formulaHelpers';

import { VariantWithLabel } from '../../../../../models/variant.model';

import { toastService } from '../../../../../services/toast.service';

const findSharedLabelIds = (
    componentIds: string[],
    grouped: Record<string, VariantWithLabel[]>,
): number[] => {
    const labelSets = componentIds.map((cid) => {
        const labelIds = grouped[cid].map((v) => v.label?.id ?? null);
        return new Set(labelIds);
    });

    // Intersect all sets
    let intersection = new Set(labelSets[0]);
    for (let set of labelSets.slice(1)) {
        intersection = new Set([...intersection].filter((l) => set.has(l)));
    }

    // Remove null, cannot match on null
    intersection.delete(null);

    return [...intersection] as number[];
};

export const pickRandomVariants = (
    groupedByComponent: Record<string, VariantWithLabel[]>,
    componentsByType: Record<string, Set<string>>,
    isLabeledMatchingEnabled: boolean,
): { component_id: string; variant: VariantWithLabel }[] | null => {
    const result = [];

    for (const componentIdSet of Object.values(componentsByType)) {
        const componentIds = [...componentIdSet];

        if (!isLabeledMatchingEnabled) {
            for (const cid of componentIds) {
                result.push({
                    component_id: cid,
                    variant: getRandom(groupedByComponent[cid]),
                });
            }
            continue;
        }

        if (componentIds.length === 1) {
            const cid = componentIds[0];
            result.push({
                component_id: cid,
                variant: getRandom(groupedByComponent[cid]),
            });
            continue;
        }

        const sharedLabelIds = findSharedLabelIds(
            componentIds,
            groupedByComponent,
        );

        if (sharedLabelIds.length === 0) {
            toastService.showNotificationToast(
                ToastStatus.Warning,
                'No common label found.',
            );
            return null;
        }

        const chosenLabelId = getRandom(sharedLabelIds);

        for (const cid of componentIds) {
            const candidates = groupedByComponent[cid].filter(
                (v) => v.label?.id === chosenLabelId,
            );

            if (candidates.length === 0) return null;

            result.push({
                component_id: cid,
                variant: getRandom(candidates),
            });
        }
    }

    return result;
};
